export default __webpack_public_path__ + "static/media/Camera Render.4ad7605e.png";